import React, { Component } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { BarChart, MediumBarChart } from '../../components/bar-chart/';
import styles from './chart-area.module.scss';
import * as selectors from '../../reducers';

class ChartArea extends Component {
  constructor() {
    super();
    this.chartMapper = this.chartMapper.bind(this);
  }

  getLegendPhrase(chartData) {
    const { activeCouncil } = this.props;
    const area = activeCouncil[chartData.area];
    return area + ' districts';
  }

  renderTrend(trend) {
    if (!trend) {
      return null;
    }

    const color = '#9a8273';
    return (
      <span
        style={{
          color,
          marginRight: 10,
        }}
      >
        {trend === '−' ? 'No Trend' : `Trend ${trend}`}
      </span>
    );
  }
  isTextBarChart(data) {
    return data.max === 'High';
  }

  chartMapper(chartData, index) {
    const {
      color,
      unit,
      activeCouncil,
      comparedCouncil,
      councils,
      visible,
      trend,
    } = this.props;

    switch (chartData.type) {
      case 'main':
        return (
          <BarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            tickIsHidden={activeCouncil.isBlank}
            visible={visible}
          >
            {this.renderTrend(trend)}
            {activeCouncil.name}
          </BarChart>
        );
      case 'compared':
        return (
          <BarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            tickIsHidden={comparedCouncil.isBlank}
            visible={visible}
          >
            {this.renderTrend(trend)}

            {comparedCouncil.name}
          </BarChart>
        );
      case 'median':
        const medianCount = councils.filter(
          council =>
            council[chartData.area] === activeCouncil[chartData.area] &&
            !council.isBlank
        );
        if (chartData.max === 'High') {
          // No median for text bar chart
          return null;
        }
        if (medianCount.length === 1) {
          return null;
        }
        return (
          <MediumBarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            visible={visible}
          >
            <div className={styles.chartLegend}>
              Median of {medianCount ? medianCount.length : 0}{' '}
              <span className={styles.chartLegendBold}>
                {this.getLegendPhrase(chartData)}
              </span>
            </div>
          </MediumBarChart>
        );
      case 'text':
      default:
        return null;
    }
  }

  render() {
    const { data } = this.props;
    return data.map(this.chartMapper);
  }
}

const mapStateToProps = state => ({
  activeCouncil: selectors.getActiveCouncil(state),
  councils: selectors.getCouncils(state),
  comparedCouncil: selectors.getComparedCouncil(state),
});

ChartArea.propTypes = {
  activeCouncil: PropTypes.object.isRequired,
  comparedCouncil: PropTypes.object,
  data: PropTypes.array.isRequired,
  color: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default connect(
  mapStateToProps,
  null
)(ChartArea);



// WEBPACK FOOTER //
// ./src/components/data-card-row/chart-area.js